// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"647":"5278cc35849722d3","792":"673f87cbc70b3d7e","907":"2a40e62e4f5dd834"}[chunkId] + ".js";
};